import React, { useCallback, useContext, useEffect, useState } from 'react'
import { motion as m } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/esm/Container';
import '../../lib/css/App.css';
import EventHome from './PageElements/EventElements/EventHome';
import { Context } from '../../lib/Context';
import Event from './PageElements/Event';
import EventHeader from './PageElements/EventElements/EventHeader';
import { calculateAge } from '../../lib/Functions/calculateAge';


const EventsPage = () => {
    const {
        API_LINK, setViewPage, setShowEventModal, viewEventID, setViewEventID, type, events, setEvent, setIsAdjudicator,
        isAdjudicator, setEvents, getEvents, isLiveEvent, usersID, dob, gender
    } = useContext(Context);
    const [filterAgeGroup, setFilterAgeGroup] = useState({ low_age: 12, high_age: 13 });
    const [filterGenderGroup, setFilterGenderGroup] = useState('Male');
    const [ageGroups, setAgeGroups] = useState([]);
    const [competitorObject, setCompetitorObject] = useState([]);
    const [eventType, setEventType] = useState('Live Events');
    const [adjudicators, setAdjudicators] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/events') {
            setViewPage('events-page');
        }

        // Find the correct event and build the age groups array
        const foundAges = events?.find(event => event._id === viewEventID)?.age_groups || [];
        setAgeGroups(foundAges);

        // if (foundAges.length > 0) {
        //     setFilterAgeGroup({ low_age: foundAges[0].low_age, high_age: foundAges[0].high_age });
        // }

        setFilterGenderGroup(gender);
        if (dob) {
            const age = calculateAge(dob);

            // Handle age group filtering directly
            for (let i = 0; i < foundAges.length; i++) {
                if (age >= foundAges[i].low_age && age <= foundAges[i].high_age) {
                    setFilterAgeGroup({
                        low_age: foundAges[i].low_age,
                        high_age: foundAges[i].high_age
                    });
                    break; // Exit loop after finding the group
                }
            }
        }
    }, [location.pathname, setViewPage, events, viewEventID, dob, gender]);

    const handleSetFilterAgeGroups = (group) => {
        setFilterAgeGroup(group);
    }

    const handleSetFilterGenderGroups = (group) => {
        setFilterGenderGroup(group);
    }

    const handleClearEventInfo = () => {
        setViewEventID('');
        if (isAdjudicator) {
            fetch(API_LINK + '/get-events', {
                credentials: 'include',
                method: 'GET'
            }).then(response => {
                response.json().then(data => {
                    setEvents(data.events);
                })
            })
        }
        setIsAdjudicator(false);
        setEvent({});
    }

    // eslint-disable-next-line
    const handleSwitchType = async (event) => {
        await getEvents();
        setIsAdjudicator(false);
        setEventType(event);
    }

    const getCompetitors = useCallback(async (eventID) => {
        setIsLoading(true);
        let response = await fetch(API_LINK + '/get-competitor-object', {
            method: 'POST',
            body: JSON.stringify({ eventID, isLiveEvent, isAdjudicator, userID: usersID }),
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include'
        })
        if (response.ok) {
            response.json().then(async data => {
                if (data.error) {
                    console.log('There was an error: ' + data.error);
                } else {
                    setCompetitorObject(data.competitors);
                    setAgeGroups(data.age_groups);
                    if (isLiveEvent) {
                        setAdjudicators(data.adjudicators);
                    }
                    setIsLoading(false);
                }
            });
        }
    }, [API_LINK, setCompetitorObject, isLiveEvent, isAdjudicator, usersID, setAgeGroups]);


    // Does this work now?

    return (
        <m.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.75, ease: 'easeOut' }}>
            <div className="gradient-bg" style={{ minHeight: '100vh', fontFamily: "Urbanist", marginTop: '-0px' }}>
                {!viewEventID ? (
                    <Container style={{ paddingTop: '20px', paddingBottom: '20px', color: 'white' }}>
                        <EventHeader
                            eventType={eventType}
                            handleSwitchType={handleSwitchType}
                            setShowEventModal={setShowEventModal}
                            viewEventID={viewEventID}
                            type={type}
                        />
                        <EventHome eventType={eventType} getCompetitors={getCompetitors} />
                    </Container>
                ) : (
                    <div style={{ paddingTop: '20px', paddingBottom: '20px', color: 'white', width: '100%' }}>
                        <Container style={{ paddingTop: '0', paddingBottom: '0' }}>
                            <EventHeader
                                eventType={eventType}
                                handleSwitchType={handleSwitchType}
                                setShowEventModal={setShowEventModal}
                                viewEventID={viewEventID}
                                type={type}
                            />
                        </Container>
                        <Event
                            isAdjudicator={isAdjudicator}
                            handleClearEventInfo={handleClearEventInfo}
                            ageGroups={ageGroups}
                            filterAgeGroup={filterAgeGroup}
                            handleSetFilterAgeGroups={handleSetFilterAgeGroups}
                            filterGenderGroup={filterGenderGroup}
                            handleSetFilterGenderGroups={handleSetFilterGenderGroups}
                            competitorObject={competitorObject}
                            setCompetitorObject={setCompetitorObject}
                            getCompetitors={getCompetitors}
                            adjudicators={adjudicators}
                            setAdjudicators={setAdjudicators}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                        />
                    </div>
                )}
            </div>
        </m.div >
    )
}

export default EventsPage